import { render, staticRenderFns } from "./stepStatus.vue?vue&type=template&id=6a0c510d&"
import script from "./stepStatus.vue?vue&type=script&lang=js&"
export * from "./stepStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports